export const timesheetsStatus = {
  open: "Open",
  saved: "Saved",
  submitted: "Submitted",
  approved: "Approved",
  returned: "Returned",
  processed: "Processed",
  returnedByHays: "Returned by Hays",
}
export const timesheetsStatusWorker = {
  submitted: "Submitted",
  approved: "Approved",
  processed: "Processed",
}

export const timesheetsStatusApprover = {
  approved: "Approved",
  returned: "Returned",
  processed: "Processed",
  returnedByHays: "Returned by Hays",
}

export const timesheetsStatusAsArray = function () {
  let allStatus = [];
  Object.keys(timesheetsStatus).forEach(s => {
    allStatus.push(timesheetsStatus[s])
  })

  return allStatus;
}

export const timesheetsStatusWorkerAsArray = function () {
  let allStatus = [];
  Object.keys(timesheetsStatusWorker).forEach(s => {
    allStatus.push(timesheetsStatusWorker[s])
  })

  return allStatus;
}

export const timesheetsStatusApproverAsArray = function () {
  let allStatus = [];
  Object.keys(timesheetsStatusApprover).forEach(s => {
    allStatus.push(timesheetsStatusApprover[s])
  })

  return allStatus;
}
